const translation: Record<string, string> = {
  'nav.home': '首页',
  'nav.food': '美食',
  'nav.travel': '旅行',
  'nav.fashion': '时尚',
  'nav.pets': '萌宠',
  'nav.about': '关于我们',
  'hero.title': '甜蜜生活，从蜜桃开始',
  'hero.subtitle': '记录每一个值得珍藏的甜蜜瞬间',
  'hero.cta': '立即探索',
  'hero.secondary': '成为创作者',
  'category.title': '探索内容分类',
  'category.subtitle': '发现你感兴趣的甜蜜世界',
  'category.viewAll': '查看全部',
  'hot.title': '热门推荐',
  'hot.subtitle': '大家都在看的甜蜜内容',
  'hot.views': '次播放',
  'hot.likes': '次点赞',
  'hot.duration': '时长',
  'creators.title': '精选创作者',
  'creators.subtitle': '关注这些有趣的灵魂，发现更多甜蜜内容',
  'creators.followers': '粉丝',
  'creators.follow': '关注',
  'latest.title': '最新内容',
  'latest.subtitle': '发现新鲜出炉的甜蜜故事',
  'latest.readMore': '阅读更多',
  'faq.title': '常见问题',
  'faq.subtitle': '关于蜜桃视频，你想知道的都在这里',
  'cta.title': '加入蜜桃视频',
  'cta.subtitle': '开启你的甜蜜创作之旅',
  'cta.button': '立即加入',
  'footer.brand': '蜜桃视频 · 甜蜜生活记录与创意短视频平台',
  'footer.quickLinks': '快速链接',
  'footer.categories': '内容分类',
  'footer.about': '关于我们',
  'footer.contact': '联系我们',
  'footer.copyright': '蜜桃视频 版权所有',
  'breadcrumb.home': '首页',
  'article.related': '相关推荐',
  'article.author': '作者',
  'article.views': '次阅读',
  'article.likes': '次点赞',
  'article.date': '发布于',
  'article.tags': '标签',
  'about.brand': '品牌故事',
  'about.milestones': '发展历程',
  'about.testimonials': '用户口碑',
  'about.contact': '联系我们',
  'about.email': '邮箱',
  'about.phone': '电话',
  'about.address': '地址',
  'about.wechat': '微信',
  'about.weibo': '微博',
  'scrollTop': '回到顶部',
};

export default translation;